import { NsxMarketingConsent } from '@britishgasenergy/react-nucleus';
import NsFormGroup from '@britishgasenergy/react-nucleus/dist/nuc-components/NsFormGroup';
import NsInputterEvent from '../../../common/ns-inputter/NsInputterEvent';
import { NsEmailInput } from 'components/common/ns-email-input/NsEmailInput';

import { NsSelect } from 'components/common/ns-select/NsSelect';
import {
  NsDatepicker,
  DateString
} from 'components/common/ns-datepicker/NsDatepicker';
import { NsFirstNameInput } from 'components/common/ns-first-name-input/NsFirstNameInput';
import { NsLastNameInput } from 'components/common/ns-last-name-input/NsLastNameInput';
import { NsPhoneInput } from 'components/common/ns-phone-input/NsPhoneInput';
import { NsInputterValidations } from 'components/common/ns-inputter/NsInputterValidations';
import { useMaskPII } from 'hooks/useMaskPII';
import { MeterReadPreferences } from './MeterReadPreferences';
import NsContent from 'components/common/ns-content/NsContent';
import { ChangeOfTenancy } from './ChangeOfTenancy';
import { PsrConsent } from './PsrConsent';

export const personalDetailsFormTestId = 'personalDetailsFormTestId';
export type PersonalDetailsFormProps = {
  handleChange: (event: NsInputterEvent) => void;
  account: {
    title: string;
    firstName: string;
    lastName: string;
    email: string;
    birthDate?: string;
    phoneNumber: string;
    preferredCommunicationMethod?: string;
  };
};
export const PersonalDetailsForm = ({
  handleChange,
  account
}: PersonalDetailsFormProps) => {
  const { mask } = useMaskPII();
  return (
    <NsContent data-testid={personalDetailsFormTestId}>
      <NsFormGroup legend="About you">
        <NsSelect
          name="title"
          label="Title"
          onChange={handleChange}
          value={account.title}
          inputAttributes={mask}
          placeholder="Select title"
          options={[
            { value: 'Dr' },
            { value: 'Mr' },
            { value: 'Mrs' },
            { value: 'Ms' },
            { value: 'Miss' }
          ]}
        />

        <NsFirstNameInput
          value={account.firstName}
          onChange={handleChange}
          inputAttributes={mask}
        />

        <NsLastNameInput
          value={account.lastName}
          onChange={handleChange}
          inputAttributes={mask}
        />

        <NsDatepicker
          name="birthDate"
          label="Date of birth"
          value={(account.birthDate as DateString) ?? ('' as DateString)}
          isBirthDate
          onChange={handleChange}
        />
        <NsEmailInput
          id="email"
          name="email"
          label="Email"
          value={account.email}
          onChange={handleChange}
          inputAttributes={mask}
          validations={[
            NsInputterValidations.isRequired,
            NsInputterValidations.isEmail
          ]}
        />
        <NsPhoneInput
          value={account.phoneNumber}
          onChange={handleChange}
          inputAttributes={mask}
        />

        <ChangeOfTenancy />
        <NsxMarketingConsent type="light" />
        <MeterReadPreferences />
        <PsrConsent />
      </NsFormGroup>
    </NsContent>
  );
};

export default PersonalDetailsForm;
